$('.slider_top').slick({
    slideToShow: 1,
    centerMode: true,
    centerPadding: '10%',
    autoplay: true,
    autoplaySpeed: 2800,
    speed: 1000,
    fade: true,
    dots: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          centerMode: false,
        },
      },
    ],
  });
  
  
$('.bra_title').on('click', function () {
var findElm = $(this).next('.bra_box'); 
$(findElm).slideToggle();

if ($(this).hasClass('bra_close')) {
    $(this).removeClass('bra_close');
} else {
    $(this).addClass('bra_close');
}
});